import * as React from 'react';
import { useContext } from 'react';
import { Box, Button, Typography } from '@mui/material';
import { AuthContext } from 'react-oauth2-code-pkce';
import { SleepingCowImage } from '@app/icons';
import { AUTH_POPUP_WINDOW_NAME } from '@utils/auth-relay';
import { isIframe } from '@utils/iframe';
import { rememberPageBeforeSignIn } from '@utils/sign-in-redirect';

const RequestAuth: React.FC = () => {
  const { login } = useContext(AuthContext);

  // Azure AD refuses to render inside any iframe, so in the widget the IdP hop
  // needs a real popup. The popup runs this same app at the root, logs in
  // there, then relays the resulting tokens back via postMessage (see App.tsx).
  // A top-level window simply signs in by redirect.
  const onAuthClick = () => {
    if (!isIframe) {
      rememberPageBeforeSignIn();
      login();

      return;
    }
    window.open(
      window.location.origin,
      AUTH_POPUP_WINDOW_NAME,
      'width=600,height=700'
    );
  };

  return (
    <Box display="flex" flexDirection="column" flexGrow={1} p={6}>
      <Box alignItems="center" display="flex" justifyContent="center">
        <Typography textAlign="center" variant="subtitle1">
          Please sign in to continue
        </Typography>
      </Box>
      <Box alignItems="center" display="flex" justifyContent="center" mt={3}>
        <Button color="primary" variant="contained" onClick={onAuthClick}>
          Sign In
        </Button>
      </Box>
      <Box display="flex" justifyContent="center" mt={3}>
        <SleepingCowImage />
      </Box>
    </Box>
  );
};

export default RequestAuth;
